import React from 'react';

import { ClauseText, DangerText, InfoText } from './Components/ContractText';

interface Props {
  daysToSelectTitleCompany?: number;
  buyerName?: string;
  sellerName?: string;
}

const TitleandSurvey = ({
  daysToSelectTitleCompany,
  buyerName,
  sellerName,
}: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Titles, Surveys, and Costs
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Within <ClauseText>{daysToSelectTitleCompany || ' '} </ClauseText>
          days from the Execution Date is of this Agreement, Buyer will order
          from a reputable title company for delivery to Seller a comprehensive
          title report on the Property. Upon receipt, Buyer will deliver a free
          copy of the title report to Seller
        </li>
        <li>
          Buyer is encouraged to obtain an owner’s title insurance policy to
          protect Buyer. An owner’s title insurance policy is different from a
          lender’s title insurance policy, which will not protect Buyer from
          claims and attacks on the title. Owner’s title insurance policies come
          in standard and enhanced versions; Buyer should consult with a title
          insurance agent about Buyer’s options. Buyer agrees to release and
          discharge any and all claims and losses against Broker for Buyer
          should Buyer neglect to obtain an owner’s title insurance policy.
        </li>
        <li>
          Buyer will pay for the following:
          <ul className="text-black mb-2 text-base list-disc list-inside text-bold">
            <li>
              Title search, title insurance and/or mechanics' lien insurance, or
              any fee for cancellation.
            </li>
            <li>
              Flood insurance, fire insurance, hazard insurance, mine subsidence
              insurance, or any fee for cancellation.
            </li>
            <li>
              Appraisal fees and charges paid in advance to mortgage lender.
            </li>
            <li>Buyer's customary settlement costs and accruals.</li>
          </ul>
        </li>
        <li>
          Any survey or surveys required by the title insurance company or the
          abstracting company for preparing an adequate legal description of the
          Property (or the correction thereof) will be obtained and paid for by
          Seller. Any survey or surveys desired by Buyer or required by the
          mortgage lender will be obtained and paid for by Buyer.
        </li>
        <li>
          The Property will be conveyed with good and marketable title that is
          insurable by a reputable title insurance company at the regular rates,
          free and clear of all liens, encumbrances, and easements, excepting
          however the following: existing deed restrictions; historic
          preservation restrictions or ordinances; building restrictions;
          ordinances; easements of roads; easements visible upon the ground;
          easements of record; and privileges or rights of public service
          companies, if any.
        </li>
        <li>
          If a change in Seller’s financial status affects Seller’s ability to
          convey title to the Property on or before the Settlement Date, or any
          extension there of Seller shall promptly notify Buyer in writing. A
          status includes, but is not limited to, Seller filing bankruptcy;
          filing of a foreclosure lawsuit against the Property; entry of a
          monetary judgment against Seller; notice of public tax sale affecting
          the Property; and Seller learning that the sale price of the Property
          is no longer sufficient to satisfy all liens and encumbrances against
          the Property.
        </li>
        <li>
          If Seller is unable to give good and marketable title that is
          insurable by a reputable title insurance company at the regular rates,
          Buyer may terminate this Agreement by written notice to Seller, with
          all deposit money returned to Buyer according to the terms of this
          Agreement, or take such title as Seller can convey If the title
          condition precludes Seller from conveying title, Buyer’s sole remedy
          shall be to terminate this Agreement. Upon termination, all deposit
          money shall be returned to Buyer according to the terms of this
          Agreement and Seller will reimburse Buyer for any costs incurred by
          Buyer for any inspections or certifications obtained according to the
          terms of this Agreement.
        </li>
      </ol>
    </div>
  );
};

export default TitleandSurvey;
